import axios from "axios"
import { AD_POST_ATTEMPTS_URL } from "src/constants"

export const createAdPostAttempts = async (data) => {
  return await axios.post(AD_POST_ATTEMPTS_URL, data)
}
